import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { edit, getDetail as _getDetail, create } from '@/api/setting/task';
import { mapState } from 'vuex';
export default {
  name: 'task-form',
  props: {
    id: {
      default: undefined
    },
    onlyReady: {
      default: false
    }
  },
  data: function data() {
    return {
      form: {
        partners: [],
        managers: [],
        leaders: [],
        IQCP: [],
        IQC: [],
        maintainer: [],
        viewers: [],
        n02Qclevel: '3',
        sender: [],
        replyPerson: [],
        admin: [],
        n02StrucCode: undefined,
        n02RiskLevel: undefined
      },
      rules: {
        n02StrucCode: [{
          required: true,
          message: '请选择架构编码',
          trigger: 'change'
        }],
        n02RiskLevel: [{
          required: true,
          message: '请选择风险等级',
          trigger: 'change'
        }],
        partners: [{
          required: true,
          message: '请选择合伙人',
          trigger: 'change'
        }],
        managers: [{
          required: true,
          message: '请选择经理',
          trigger: 'change'
        }],
        leaders: [{
          required: true,
          message: '请选择现场负责人',
          trigger: 'change'
        }],
        n02Qclevel: [{
          required: true,
          message: '请选择质控层级',
          trigger: 'change'
        }],
        IQCP: [{
          required: true,
          message: '请选择独立质控合伙人',
          trigger: 'change'
        }],
        IQC: [{
          required: true,
          message: '请选择独立质控人',
          trigger: 'change'
        }],
        viewers: [{
          required: true,
          message: '请选择授权查询人员',
          trigger: 'change'
        }],
        admin: [{
          required: true,
          message: '请选择函证中心管理员',
          trigger: 'change'
        }]
        // sender: [
        //   { required: true, message: '请选择发函操作员', trigger: 'change' }
        // ],
        // replyPerson: [
        //   { required: true, message: '请选择回函操作员', trigger: 'change' }
        // ]
      },
      strucCodeOptions: [],
      qCLevelOptions: [{
        value: '5'
      }, {
        value: '4'
      }, {
        value: '3'
      }, {
        value: '0'
      }],
      loading: false,
      partners: [],
      timer: null,
      data: {}
    };
  },
  methods: {
    changeStrucCode: function changeStrucCode() {
      var params = {
        partners: [],
        managers: [],
        leaders: [],
        IQCP: [],
        IQC: [],
        maintainer: [],
        viewers: [],
        n02Qclevel: '3',
        sender: [],
        replyPerson: [],
        admin: []
      };
      this.form = _objectSpread(_objectSpread({}, this.form), params);
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var roles, staffs, self, list, form, initStaffInfo, _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, _yield$_this$$awaitTo3, _yield$_this$$awaitTo4, _err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              initStaffInfo = function _initStaffInfo(key) {
                var type = {
                  'partners': '合伙人',
                  'managers': '经理',
                  'leaders': '现场负责人',
                  'IQCP': '独立质控合伙人',
                  'IQC': '独立质控人',
                  'viewers': '查询人',
                  'maintainer': '维护人',
                  admin: '函证中心管理员',
                  sender: '发函操作员',
                  replyPerson: '回函操作员'
                };
                var staff;
                form[key].forEach(function (id) {
                  if (self.id) {
                    staff = self.data.roles.find(function (item) {
                      return item.id === id;
                    });
                  }
                  if (staff) {
                    roles.push(_objectSpread(_objectSpread({}, staff), {}, {
                      n21StaffName: staff.name,
                      n21Staff: staff.id,
                      n21Role1: type[key]
                    }));
                  } else {
                    var item = list.find(function (item) {
                      return item.id === id;
                    });
                    if (item) {
                      roles.push({
                        n21StaffName: item.name,
                        n21Staff: item.id,
                        n21Role1: type[key]
                      });
                    }
                  }
                });
              };
              if (!_this.onlyReady) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return _this.$checkForm();
            case 2:
              roles = [];
              staffs = _this.staffsList;
              self = _this;
              list = staffs;
              form = _this.form;
              _this.loading = true;
              if (_this.isStruc) {
                initStaffInfo('admin');
                initStaffInfo('sender');
                initStaffInfo('replyPerson');
              } else {
                initStaffInfo('partners');
                initStaffInfo('managers');
                initStaffInfo('leaders');
                initStaffInfo('IQCP');
                initStaffInfo('IQC');
                initStaffInfo('viewers');
                initStaffInfo('maintainer');
              }
              if (!_this.id) {
                _context.n = 5;
                break;
              }
              _context.n = 3;
              return _this.$awaitTo(edit({
                id: _this.id
              }, {
                info: _objectSpread({
                  n02Id: _this.id
                }, _this.form),
                roles: roles
              }));
            case 3:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              _this.loading = false;
              if (!err) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              _context.n = 7;
              break;
            case 5:
              _context.n = 6;
              return _this.$awaitTo(create({
                info: _this.form,
                roles: roles
              }));
            case 6:
              _yield$_this$$awaitTo3 = _context.v;
              _yield$_this$$awaitTo4 = _slicedToArray(_yield$_this$$awaitTo3, 1);
              _err = _yield$_this$$awaitTo4[0];
              _this.loading = false;
              if (!_err) {
                _context.n = 7;
                break;
              }
              return _context.a(2);
            case 7:
              _this.$message.success('操作成功');
              _this.loading = false;
              _this.$emit('submit');
            case 8:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getDetail: function getDetail() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_getDetail, data, info, roles, form, staffType;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _getDetail({
                id: _this2.id
              });
            case 1:
              _yield$_getDetail = _context2.v;
              data = _yield$_getDetail.data;
              info = data.info, roles = data.roles;
              form = info;
              _this2.data = data;
              if (Array.isArray(roles) && roles.length) {
                staffType = {
                  '合伙人': 'partners',
                  '经理': 'managers',
                  '现场负责人': 'leaders',
                  '独立质控合伙人': 'IQCP',
                  '独立质控人': 'IQC',
                  '查询人': 'viewers',
                  '维护人': 'maintainer',
                  '函证中心管理员': 'admin',
                  '发函操作员': 'sender',
                  '回函操作员': 'replyPerson'
                };
                roles.forEach(function (item) {
                  if (staffType[item.n21Role1]) {
                    if (!Array.isArray(form[staffType[item.n21Role1]])) {
                      form[staffType[item.n21Role1]] = [item.n21Staff];
                    } else {
                      form[staffType[item.n21Role1]].push(item.n21Staff);
                    }
                  }
                });
              }
              _this2.form = _objectSpread(_objectSpread({}, _this2.form), form);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('cpscc', ['staffsList', 'strucList'])), {}, {
    isStruc: function isStruc() {
      return this.form.n02StrucCode && this.form.n02StrucCode.length === 4;
    }
  }),
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (_this3.id) {
              _this3.getDetail();
            }
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }))();
  },
  mounted: function mounted() {
    var _this4 = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () {
      _this4.$refs.form.clearValidate();
    });
  },
  destroyed: function destroyed() {
    clearTimeout(this.timer);
  }
};